<template>
  <UiCard
    class="animate-pulse border border-outline-variant gap-2 p-0 overflow-hidden"
  >
    <div class="bg-on-surface-variant/20 w-full aspect-video"></div>
    <div class="p-3 space-y-3">
      <div class="h-5 bg-on-surface-variant/20 rounded w-5/6"></div>
      <div class="h-4 bg-on-surface-variant/20 rounded w-1/2"></div>
    </div>
  </UiCard>
</template>
